/**
 * 鸡实体
 */
export class ChickEntity{

    id : number;//id
    name : string;//名称
    desc : string;//描述
    imgPath : string;//图片路径
    recyclePrice : number;//回收价格

    becomeBigId ?: number;// 变大id
    becomeBigSeconds ?: number;//长大秒数

    purchasePrice ?: number;//购买价格

    layingEggSeconds ?: number;//生蛋时间
    eggWeightArray ?: { goodsId : number,weight : number }[];//生蛋id 物品数组

}

/**
 * 鸡 配置
 * @constructor
 */
export default function ChickConfig() {
    let dataList : ChickEntity[] = [
        //白羽鸡
        // {
        //     id : 1,
        //     name : "白羽鸡",
        //     desc : "扶贫助农指定互联网供特需产品，价格实惠，味道鲜美，产蛋量巨大 ",
        //     imgPath : "04",
        //     recyclePrice : 1,
        //     becomeBigId : 2,
        //     becomeBigSeconds : 15,
        //     purchasePrice : 200,
        //     eggWeightArray : [
        //         { goodsId : 21001,weight : 95 },
        //         { goodsId : 21002,weight : 5 },
        //     ],
        // },

        // //背带鸡
        // {
        //     id : 3,
        //     name : "背带鸡",
        //     desc : " 中分 背带裤 会打篮球和rap。鸡中巨星。练习飞行时长两年半的全民偶像。每次登场总会吸引全场的目光",
        //     imgPath : "03",
        //     recyclePrice : 1,
        //     becomeBigId : 4,
        //     becomeBigSeconds : 30,
        //     purchasePrice : 500,
        //     eggWeightArray : [
        //         { goodsId : 21001,weight : 90 },
        //         { goodsId : 21002,weight : 5 },
        //         { goodsId : 21003,weight : 5 },
        //     ],
        // },

        // //战斗鸡
        // {
        //     id : 5,
        //     name : "战斗鸡",
        //     desc : "师从大洋彼岸的功夫巨星小小龙，精通各种武术，肌肉发达。它的肉质紧实，也难逃被宰杀的命运",
        //     imgPath : "01",
        //     recyclePrice : 1,
        //     becomeBigId : 6,
        //     becomeBigSeconds : 60,
        //     purchasePrice : 500,
        //     eggWeightArray : [
        //         { goodsId : 21001,weight : 90 },
        //         { goodsId : 21002,weight : 5 },
        //         { goodsId : 21003,weight : 5 },
        //     ],
        // },

        // //似鸟龙
        // {
        //     id : 7,
        //     name : "似鸟龙",
        //     desc : "介乎鸟与恐龙之间，被圣血麒麟蛋强大的魔法影响变异而成。是乾坤宫的战斗宠物",
        //     imgPath : "02",
        //     recyclePrice : 1,
        //     becomeBigId : 8,
        //     becomeBigSeconds : 180,
        //     purchasePrice : 2000,
        //     eggWeightArray : [
        //         { goodsId : 21001,weight : 60 },
        //         { goodsId : 21002,weight : 20 },
        //         { goodsId : 21003,weight : 15 },
        //         { goodsId : 21004,weight : 5 },
        //     ],
        // },

        // {
        //     id : 2,
        //     name : "白羽鸡",
        //     desc : "扶贫助农指定互联网供特需产品，价格实惠，味道鲜美，产蛋量巨大",
        //     imgPath : "04",
        //     recyclePrice : 1,
        //     layingEggSeconds : 30,
        //     eggWeightArray : [
        //         { goodsId : 21001,weight : 95 },
        //         { goodsId : 21002,weight : 5 },
        //     ],
        // },
        // {
        //     id : 4,
        //     name : "背带鸡",
        //     desc : " 中分 背带裤 会打篮球和rap。鸡中巨星。练习飞行时长两年半的全民偶像。每次登场总会吸引全场的目光",
        //     imgPath : "03",
        //     recyclePrice : 1,
        //     layingEggSeconds : 30,
        //     eggWeightArray : [
        //         { goodsId : 21001,weight : 90 },
        //         { goodsId : 21002,weight : 5 },
        //         { goodsId : 21003,weight : 5 },
        //     ],
        // },
        // {
        //     id : 6,
        //     name : "战斗鸡",
        //     desc : "师从大洋彼岸的功夫巨星小小龙，精通各种武术，肌肉发达。它的肉质紧实，也难逃被宰杀的命运",
        //     imgPath : "01",
        //     recyclePrice : 1,
        //     layingEggSeconds : 30,
        //     eggWeightArray : [
        //         { goodsId : 21001,weight : 90 },
        //         { goodsId : 21002,weight : 5 },
        //         { goodsId : 21003,weight : 5 },
        //     ],
        // },
        // {
        //     id : 8,
        //     name : "似鸟龙",
        //     desc : "介乎鸟与恐龙之间，被圣血麒麟蛋强大的魔法影响变异而成。是乾坤宫的战斗宠物",
        //     imgPath : "02",
        //     recyclePrice : 1,
        //     layingEggSeconds : 30,
        //     eggWeightArray : [
        //         { goodsId : 21001,weight : 70 },
        //         { goodsId : 21002,weight : 15 },
        //         { goodsId : 21003,weight : 10 },
        //         { goodsId : 21004,weight : 5 },
        //     ],
        // },
        // //凤凰
        // {
        //     id : 9,
        //     name : "凤凰",
        //     desc : "白鸟之王，至尊无上。乾坤宫护法们的坐骑，喜欢叼着夜明珠，遇见会使人飞黄腾达，青云直上。",
        //     imgPath : "default",
        //     recyclePrice : 1,
        //     layingEggSeconds : 30,
        //     eggWeightArray : [
        //         { goodsId : 21005,weight : 100 },
        //     ],
        // },
        // //神龙宝宝
        // {
        //     id : 10,
        //     name : "神龙宝宝",
        //     desc : "威风凌凌的龙宝宝,具有强大的神秘力量。龙王的坐骑，可繁育出使人起死回生的圣血麒麟蛋。",
        //     imgPath : "default",
        //     recyclePrice : 1,
        //     layingEggSeconds : 30,
        //     eggWeightArray : [
        //         { goodsId : 21007,weight : 100 },
        //     ],
        // },
    ];
    return dataList;
}

/**
 * 获取小鸡 列表
 */
export function getYoungList() : ChickEntity[]{
    let datalist = ChickConfig();
    return datalist.filter((item,index,dataList)=>{return item.becomeBigId } );
}
//通过id获取鸡腿
export function getChickEntityById( id : number ){
    return ChickConfig().find((item,index,dataList)=>{return item.id == id });
}
